import { Injectable } from '@angular/core';
import { GetPeopleDataByEmailResponseDto } from '@fdm/api-client';

@Injectable({
  providedIn: 'root'
})
export class EmailDescriptionService {

  processOwnerDescriptions(owners: GetPeopleDataByEmailResponseDto[], selectedEmail?: string | null): string {
    if (!owners || owners.length === 0) {
      return '';
    }

    const selected = selectedEmail?.trim().toLowerCase();
    return owners
      .filter(owner => !selected || [owner.email, owner.preferredEmail, owner.sharedEmail]
        .some(email => email?.trim().toLowerCase() === selected))
      .map(owner => this.describePerson(owner))
      .filter(Boolean)
      .join('\n\n');
  }

  private describePerson(owner: GetPeopleDataByEmailResponseDto): string {
    const description = (owner.description ?? '').replace(/, email:\s*[^,]+/, '').trim();
    const emails = [
      ['Email', owner.email],
      ['Preferred email', owner.preferredEmail],
      ['Shared email', owner.sharedEmail],
    ]
      .filter(([, email]) => !!email?.trim())
      .map(([label, email]) => `${label}: ${email!.trim()}`);

    return [description, ...emails].filter(Boolean).join('\n');
  }

   getPreferredEmail(owners: GetPeopleDataByEmailResponseDto[]): string | null {
    if (!owners || owners.length === 0) {
      return null;
    }
 
    // const owner = owners[0];
    const owner = owners[owners.length - 1];
    if (owner.sharedEmail && owner.sharedEmail.trim() !== '') {
      return owner.sharedEmail;
    } else if (owner.preferredEmail && owner.preferredEmail.trim() !== '') {
      return owner.preferredEmail;
    }
    return null;
  }

  getPreferredEmailForApprovalFlow(owners: GetPeopleDataByEmailResponseDto[]): string | null {
    if (!owners || owners.length === 0) {
      return null;
    }

    const firstPreferredEmail = owners
      .map(owner => owner.preferredEmail?.trim())
      .find((email): email is string => !!email);

    if (firstPreferredEmail) {
      return firstPreferredEmail;
    }

    const firstSharedEmail = owners
      .map(owner => owner.sharedEmail?.trim())
      .find((email): email is string => !!email);

    return firstSharedEmail ?? null;
  }
}
